import React, { useContext } from "react";
import './Loader.scss';
import MyContext from "../Context/MyContext";

const Loader = () => {

  const{loader} = useContext(MyContext)
  return (

    <>
    {
      loader &&
    <div className="loader-container">
      <div className="loader"></div>
    </div>

    }

    </>
  );
};

export default Loader;
